// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Redux:
import { getFaqsData } from 'actions/page'

class Faqs extends React.Component {
	componentDidMount() {
		this.props.dispatch( getFaqsData() )
	}

	handleAccordionTitleClick = ( e ) => {
		const section = e.currentTarget.parentNode
		const content = section.querySelector( '.accordion-content' )
		const height = section.getAttribute( 'data-height' )

		if ( ! section.classList.contains( 'is-active' ) && ! section.classList.contains( 'is-target' ) ) {
			section.classList.remove( 'is-not-active' )
			section.classList.add( 'is-active' )
			content.style.maxHeight = `${height}px`
		} else {
			section.classList.remove( 'is-active' )
			section.classList.add( 'is-not-active' )
			content.style.maxHeight = '0'
		}
	}

	renderCats = () => {
		const { faqsById } = this.props

		return Object.keys( faqsById ).map( key => {
			let item = faqsById[ key ]

			return (
				<div className="faqs-section" key={ item.id }>
					<h2>{ item.title }</h2>

					{ this.renderItems( item.items ) }
				</div>
			)
		} )
	}

	renderItems = ( items ) => {
		if ( ! items || ! Object.keys( items ).length ) {
			return null
		}

		return Object.keys( items ).map( key => {
			let item = items[ key ]

			return (
				<div className="accordion" key={ item.id }>
					<div className="-inner accordion-section is-not-active">
						<header className="accordion-title-b" onClick={ this.handleAccordionTitleClick }>
							<div className='-title'>
								<p dangerouslySetInnerHTML={ { __html: item.title } } />
							</div>

							<i></i>
						</header>

						<main className="accordion-content">
							<div className="-text" dangerouslySetInnerHTML={ { __html: item.content } } />
						</main>
					</div>
				</div>
			)
		} )
	}

	render() {
		const { faqsById } = this.props
		let markup = ''

		if ( ! faqsById || ! Object.keys( faqsById ).length ) {
			return null
		}

		return (
			<div className="faqs page-section">
				<div className="-inner">
					{ this.renderCats() }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		faqsById: state.page.faqsById
	}
}

export default connect( mapStateToProps )( Faqs )



// WEBPACK FOOTER //
// ./views/main/page/Faqs.jsx